module.exports = __webpack_public_path__ + "media/apps/shopper_logo-82d7f57f.svg";